import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export type IFormStructure = {
  type: string;
  label: string;
  name: string;
  value: any;
  readonly?: boolean;
  visible?: boolean;
  options?: { label: string; value: number | string | boolean }[];
  validations?: {
    name: string;
    validator: string;
    message: string;
  }[];
}

export type IdynamicForm = {
  formGroup: FormGroup;
  formControls: IFormStructure[];
}
export function createDynamicForm(
  formStructure: IFormStructure[],
  fb: FormBuilder
): IdynamicForm {
  const formGroup: Record<string, any> = {};
  formStructure.filter((control) => control.visible && control.name !== 'password').forEach((control) => {
    const controlValidators: Validators[] = [];
    if (control.validations) {
      control.validations.forEach((validation: any) => {
        if (validation.validator === 'required')
          controlValidators.push(Validators.required);
        if (validation.validator === 'email') controlValidators.push(Validators.email);
        // Add more built-in validators as needed
      });
    }

    formGroup[control.name] = [control.value || '', controlValidators];
  });
  return {
    formGroup: fb.group(formGroup),
    formControls: formStructure
  };
}
